import React, { useState } from "react";
import style from "./Sales.module.scss";
import SlidingTab from "../../../../components/SlidingTab/SlidingTab";
import SalesSplineChart from "./SalesSplineChart";
import PaymentDonutChart from "./PaymentDonutChart";
import BatchData from "./SalesTabs/BatchData";
import CardSummary from "./SalesTabs/CardSummary";
import Interchange from "./SalesTabs/InterChange";
import Deposit from "./SalesTabs/Deposit";
import useMerchantStore from "../../../../stores/merchant";

function Sales() {
  const sliding_tab_options = ["Volume", "Amount"];
  const [selectedTab, setSelectedTab] = useState("Batch Data");
  const expandDetails = useMerchantStore((state) => state.expandDetails);

  return (
    <div className={style.sales_section}>
      <div className={`${style.charts} ${expandDetails ? style.expanded : ""}`}>
        <div className={style.sales_volume}>
          <div className={style.head}>
            <h5>Sales Volume</h5>
            <SlidingTab options={sliding_tab_options} />
          </div>
          <SalesSplineChart />
        </div>

        <div className={style.card_comparison}>
          <div className={style.head}>
            <h5>Cards comparison</h5>
          </div>
          <PaymentDonutChart />
        </div>
      </div>

      <div className={style.tab_data}>
        <SlidingTab
          options={["Batch Data", "Card Summary", "Interchange", "Deposit"]}
          onChange={(e) => setSelectedTab(e)}
        />

        {selectedTab == "Batch Data" && <BatchData />}

        {selectedTab == "Card Summary" && <CardSummary />}

        {selectedTab == "Interchange" && <Interchange />}

        {selectedTab == "Deposit" && <Deposit />}
      </div>
    </div>
  );
}

export default Sales;
